import { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

interface SkillsOverviewProps {
  totalSkills: number;
  totalProjects: number;
  totalCertifications: number;
  averageProficiency: number;
}

const SkillsOverview = ({
  totalSkills,
  totalProjects,
  totalCertifications,
  averageProficiency,
}: SkillsOverviewProps) => {
  const [animatedProficiency, setAnimatedProficiency] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimatedProficiency(averageProficiency);
    }, 100);
    return () => clearTimeout(timer);
  }, [averageProficiency]);

  const stats = [
    {
      icon: 'Code2',
      label: 'Total Skills',
      value: totalSkills,
      color: 'var(--color-primary)',
    },
    {
      icon: 'FolderGit2',
      label: 'Projects Built',
      value: totalProjects,
      color: 'var(--color-secondary)',
    },
    {
      icon: 'Award',
      label: 'Certifications',
      value: totalCertifications,
      color: 'var(--color-accent)',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-surface rounded-lg p-6 border border-border hover:border-primary/50 transition-all duration-300"
        >
          <div className="flex items-center gap-3 mb-4">
            <div
              className="w-12 h-12 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: `${stat.color}20` }}
            >
              <Icon name={stat.icon} size={24} color={stat.color} />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">{stat.label}</p>
              <p className="text-2xl font-bold text-foreground">{stat.value}</p>
            </div>
          </div>
        </div>
      ))}

      <div className="bg-gradient-to-br from-primary/20 to-secondary/20 rounded-lg p-6 border border-primary/30">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 bg-background/50 backdrop-blur-sm rounded-lg flex items-center justify-center">
            <Icon name="TrendingUp" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Avg. Proficiency</p>
            <p className="text-2xl font-bold text-foreground">{averageProficiency}%</p>
          </div>
        </div>
        <div className="w-full h-2 bg-background/30 rounded-full overflow-hidden">
          <div
            className="h-full bg-primary rounded-full transition-all duration-1000 ease-out"
            style={{ width: `${animatedProficiency}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default SkillsOverview;